import React, { useState, useEffect } from 'react';
import ErrorBoundary from '@components/ErrorBoundary';
import { useSelector, useDispatch } from 'react-redux';
import { onCheckTestEvent } from '@store/common/actions';
import TestingMode from './components/testing';
import { getUserData } from '@store/user/selector';
import { checkEventDelete } from '@store/common/services';
import DeleteEvent from '@src/views/DeleteEvent';
/*Constants*/
import { RETCODE_SUCCESS } from '@configs/contants';

const BlankLayout = (props) => {
  const { routerProps, transition } = props;

  const eventId = localStorage.getItem('eventId');

  const dispatch = useDispatch();
  const userData = useSelector(getUserData);
  const [isDelete, setIsDelete] = useState(false);

  useEffect(() => {
    if (!!userData?.eventId || !!eventId) {
      handleCheckTestEvent(userData?.eventId ?? eventId);
      onCheckDeleteEventId();
    }
  }, [eventId, JSON.stringify(userData)]);

  const onCheckDeleteEventId = async () => {
    try {
      const res = await checkEventDelete(userData?.eventId ?? eventId);
      if (res?.retCode !== RETCODE_SUCCESS) {
        setIsDelete(res?.data === 'False' ? true : false);
        return;
      }
      setIsDelete(res?.data === 'False' ? true : false);
    } catch (e) {
      console.log('Error'), e;
    }
  };

  const handleCheckTestEvent = (eId) => {
    dispatch(onCheckTestEvent(eId));
  };

  return (
    <ErrorBoundary>
      <TestingMode />
      {isDelete ? <DeleteEvent /> : props.children}
    </ErrorBoundary>
  );
};

export default BlankLayout;
